var convert = require('./convert'),
    func = convert('forEach', require('../forEach'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/fp/forEach.js
// module id = 1338
// module chunks = 1